import { useEffect, useRef } from "react";

export const useClassObserver = (
    targetSelector: string,
    className: string,
    onClassAdded: () => void
) => {
    const observerRef = useRef<MutationObserver | null>(null);

    useEffect(() => {
        const targetElement = document.querySelector(targetSelector);

        if (!targetElement) return;

        observerRef.current = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.type === "attributes" && mutation.attributeName === "class") {
                    const target = mutation.target as HTMLElement;
                    if (target.classList.contains(className)) {
                        onClassAdded();
                    }
                }
            });
        });

        observerRef.current.observe(targetElement, { attributes: true });

        return () => {
            observerRef.current?.disconnect();
        };
    }, [targetSelector, className, onClassAdded]);
};
